var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwarmLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_994_1305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.26133 16.5C5.32688 16.5 3.73571 16.0258 2.48782 15.0774C1.23992 14.129 0.576667 12.9364 0.498047 11.4997H5.11189C5.15039 12.056 5.38253 12.4823 5.80831 12.7786C6.23409 13.075 6.76615 13.2235 7.4045 13.2242C8.48771 13.2242 9.02931 12.9177 9.02931 12.3048C9.02931 11.9984 8.90847 11.7637 8.66679 11.6007C8.4251 11.4376 7.99463 11.27 7.37537 11.0979L4.44653 10.3506C2.0093 9.71872 0.789881 8.21488 0.788263 5.83904C0.788263 4.5558 1.32987 3.51174 2.41308 2.70687C3.49629 1.902 4.97681 1.50053 6.85464 1.50245C8.51828 1.50245 9.90627 1.90953 11.0186 2.72369C12.1309 3.53785 12.7457 4.68252 12.8628 6.15769H8.45131C8.27692 5.27688 7.7159 4.83631 6.76825 4.83599C5.78145 4.83599 5.28822 5.14247 5.28854 5.75541C5.28854 6.29178 5.78178 6.66538 6.76825 6.87621L9.40882 7.56589C10.8599 7.95038 11.9045 8.50597 12.5425 9.23266C13.1805 9.95935 13.4997 10.9071 13.5 12.076C13.5 13.3977 12.9197 14.4658 11.7592 15.2802C10.5986 16.0947 9.09936 16.5013 7.26133 16.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_994_1305",
    x: 0.498047,
    y: 0.502441,
    width: 14.002,
    height: 15.9976,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: -0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_994_1305"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_994_1305",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwarmLogo);
export default __webpack_public_path__ + "static/media/swarm-logo.d02dbe4ecfc6914accc2c5d3d3cc68fd.svg";
export { ForwardRef as ReactComponent };